import { ControlValueAccessor, NG_VALUE_ACCESSOR, ControlContainer, NgForm, NgModel, NG_VALIDATORS, Validator, UntypedFormControl } from '@angular/forms';
import { Component, forwardRef, Input, Output, EventEmitter, ViewChild, OnInit } from '@angular/core';
import { AnswerOption } from 'app/models/form-question';
import { appendTimeData } from 'app/shared/utilities/formatters';
import { dateToISOString } from './date-field.component';

const noop = () => { };

@Component({
  selector: 'weekend-field',
  templateUrl: './weekend-field.component.html',
  // viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => WeekendFieldComponent), multi: true },
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => WeekendFieldComponent), multi: true }
  ]
})
export class WeekendFieldComponent implements OnInit, ControlValueAccessor, Validator {

  @Input('mandatory') mandatory: boolean = false;
  @Input('name') name: string;
  @Input('readOnly') readOnly: boolean = false;

  @Output('onValidChange') onValidChange = new EventEmitter();

  private weekendFieldValue: string = null;
  private weeksToDisplay: number = 12;

  public upcomingWeekendsDisplay: AnswerOption[] = [];
  private weekendStringMappedToSaturdayDate: { [key: string]: Date } = {};

  private invalid: boolean = false;

  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  constructor() {}

  ngOnInit(){
    const daysUntilSaturday = 6 - new Date().getDay();

    for (let i = 0; i < this.weeksToDisplay; i++) {
      const saturday = this.getFutureDate(new Date(), 7 * i + daysUntilSaturday);
      const weekendString = this.formatWeekendStringFromSaturdayDate(saturday);
      // add value to answerOptions array, add key value pair to calculate formQuestion.answer for db
      this.upcomingWeekendsDisplay.push({ value: weekendString });
      this.weekendStringMappedToSaturdayDate[weekendString] = saturday;
    }
  }

  get value(): string {
    return this.weekendFieldValue;
  };

  set value(v: string) {
    if (v !== this.weekendFieldValue) {
      this.weekendFieldValue = v;
      this.onChangeCallback(v ? dateToISOString(this.weekendStringMappedToSaturdayDate[v]) : null);
    }
  }

  handleChange() {
    this.invalid = !!this.validationErrors()
    if (!this.invalid) this.onValidChange.emit();
  }

  onChange() {
    this.onTouchedCallback();
  }

  writeValue(value: string) {
    if(!value) return;

    if(value.toString().match(/\d\d\d\d-\d{1,2}-\d{1,2}/)) {
      this.weekendFieldValue = this.formatWeekendStringFromSaturdayDate(appendTimeData(value));
    }
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  validate(control: UntypedFormControl) {
    return this.validationErrors()
  }

  validationErrors() {
    if (this.mandatory && (!this.weekendFieldValue || !this.weekendFieldValue.length)) {
      return { mandatoryError: true };
    }

    return null;
  }

  // takes a date and number as arguments, returns a Date daysPastBaseDate in the future
  private getFutureDate(baseDate: Date, daysPastBaseDate: number) {
    const date = new Date(baseDate);
    date.setDate(date.getDate() + daysPastBaseDate);
    return date;
  }

  private formatWeekendStringFromSaturdayDate(saturday: Date) {
    // creates date string in format 'Oct 02' from Date object
    const formatMonthDayString = (date: Date) => date.toLocaleDateString('en-US', { month: 'short', day: '2-digit' });
    const sunday = this.getFutureDate(saturday, 1);

    return `${formatMonthDayString(saturday)} - ${formatMonthDayString(sunday)}`;
  }
}
